import React, { useState } from "react";
import AddIcon from "../../Images/icon/add-icon-big.svg";
import AddIconWhite from "../../Images/icon/add-icon-white.svg";

export default function AddBtnOutlined({
  btnLabel = "Add Something",
  isDisabled = false,
  showActiveDot = false,
  CustomStyles,
  onClick,
  width,
  iconNormal,
  iconHover,
}) {
  const [onFocusStatus, setOnFocusStatus] = useState(false);

  return (
    <div
      onMouseOver={() => setOnFocusStatus(true)}
      onMouseOut={() => setOnFocusStatus(false)}
      onClick={onClick}
      className={`px-5 h-s36  flex items-center justify-center rounded-br5 select-none ring-[1px] ring-cBrand w-fit relative
      hover:text-white hover:bg-cBrand duration-300
      text-cBrand text-fs14 font-fw500
      ${isDisabled ? "cursor-not-allowed" : "cursor-pointer"}
      ${CustomStyles}    
      ${width} 
      `}
    >
      <div className="w-s16 h-sw-s16 mr-s10">
        <img
          src={onFocusStatus === true ? iconHover ?? AddIconWhite : iconNormal ?? AddIcon}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="capitalize">{btnLabel}</div>
      {showActiveDot ? <div className="absolute w-s10 h-s10 rounded-full bg-cMainBlue -right-s5 top-0"></div> : ""}
    </div>
  );
}
